module.exports = __webpack_public_path__ + "static/challenger-d3f5113994a1ee5713a2c8929210bb5b.webp";